import Vue from "vue"
var vm = new Vue()
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";

// 导出PDF
export function exportPdfFile(document, elementId, fileName) {

	// return new Promise((resolve,reject) => {
	// 	const ele = document.querySelector(`#${elementId}`);
	// 	const css = document.querySelectorAll('.report')
	// 	// document.body.appendChild(ele);
	// 	// ele.style.width =  css[0].offsetWidth + 'px';
	// 	// ele.style.height = css[0].offsetHeight + 'px';
	// 	// ele.setAttribute("style","transform:scale(10);");

    //     html2Canvas(ele, {
    //       useCORS: false //看情况选用上面还是下面的，
    //     }).then(function(canvas) {
	// 		// document.body.appendChild(canvas);
    //       let contentWidth = canvas.width
    //       let contentHeight = canvas.height
    //       let pageHeight = contentWidth / 592.28 * 841.89
    //       let leftHeight = contentHeight
    //       let position = 0
    //       let imgWidth = 595.28
    //       let imgHeight = 592.28 / contentWidth * contentHeight
    //       let pageData = canvas.toDataURL('image/jpeg', 1.0)
    //       let PDF = new JsPDF('', 'pt', 'a4')
    //       if (leftHeight < pageHeight) {
    //         PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    //       } else {
    //         while (leftHeight > 0) {
    //           PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
    //           leftHeight -= pageHeight
    //           position -= 841.89
    //           if (leftHeight > 0) {
    //             PDF.addPage()
    //           }
    //         }
    //       }
    //       PDF.save(fileName + '.pdf')

    //       let pdfFlow = PDF.output('datauristring')//获取base64Pdf
    //       console.log(pdfFlow)

    //       resolve(pdfFlow)

    //       // resolve(pageData)      //获取base64png
    //     })
    //   })


	return new Promise((resolve, reject) => {
		vm.getPdf(elementId, fileName || '未命名').then((res) => {
			resolve()
		})
	});
}